module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "searchbar-user",
    class: {
      'hotmart-pro': _vm.topBarConfig.user.ucode
    }
  }, [_c('div', {
    staticClass: "container no-padding"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "fa icon-kp-mail",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n      " + _vm._s(_vm.$t('account.header.title')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('account.header.subtitle')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "dataTables_filter search-flex"
  }, [_c('label', [_c('input', {
    staticClass: "kp-input-search",
    attrs: {
      "placeholder": _vm.$t('account.header.searchAccount'),
      "type": "text"
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "kp-filter-action"
  }, [_c('a', {
    staticClass: "none-mobile pull-right kp-button",
    on: {
      "click": function($event) {
        _vm.modalOpen('edit-account');
        _vm.resetActiveAccount();
      }
    }
  }, [_c('span', {
    staticClass: "icon-kp-plus"
  }), _vm._v(_vm._s(_vm.$t('account.actions.new')) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "filter_search icon-search"
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b98fb05","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/screens/Layout/components/MailServiceHeader.vue
// module id = 271
// module chunks = 1